angular.module("app").controller("SkinGameWinnersPageController", [
    '$scope',
    'preloadedList',
    '$timeout',
    'pagination',
    'casinoGameService',
    'errorHandler',
    'pageStatuses',
    '$state',
    'logger',
    '$uibModal',
    'settingsService',
    function ($scope, preloadedList, $timeout, pagination, casinoGameService, errorHandler, pageStatuses, $state, logger, $modal, settingsService) {

        var pendingListRequest;

        $scope.winners = angular.copy(preloadedList.gameSkinWinners);
        $scope.pageStatuses = angular.copy(pageStatuses);
        $scope.filterOptions = {
            status: pageStatuses[0]
        };

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedList.total_count);


        $scope.updateList = function (requestData) {
            requestData = angular.extend({}, requestData, getFilters());

            settingsService.setFilters(requestData);
            casinoGameService.getGameSkinWinners(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.winners = angular.copy(response.gameSkinWinners);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.publishWinner = function (winner) {
            var requestData = {
                gameSkinWinner: {
                    id: winner.id,
                    status: pageStatuses[0]
                }
            };

            casinoGameService.editGameSkinWinner(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pagination.changePage();
                        logger.logSuccess("Winner has been successfully published");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };


        $scope.deleteWinner = function (winner) {
            var requestData = {
                gameSkinWinner: {
                    id: winner.id,
                    status: pageStatuses[2]
                }
            };

            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                casinoGameService.editGameSkinWinner(requestData).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.pagination.changePage();
                            logger.logSuccess("Winner has been successfully archived");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            })
        };

        $scope.editWinner = function (winner) {
            $state.go("main.casinoGames.skinGameWinners.edit", {winnerId: winner.id});
        };


        function getFilters() {
            return {
                status: $scope.filterOptions.status
            }
        }
    }
]);